import {
	integrationGetCVContent,
	integrationGetUserDetails,
	integrationListCVList,
} from "shared/src/libs/apiLib/apiLib"
import { FileFetchingDetails, IntegrationData, PlatformIntegrationData } from "../Integrations.types"

const callbackUrl = `${window.location.origin.toString()}/oauthcallback`

export const vincereIntegrationData: PlatformIntegrationData<
	"oauthLogin" | "setupUser" | "candidateProfile" | "chooseFile" | "fetchFile" | "confirmationPage"
> = {
	allowChat: false,
	parameterMapping: {
		clientId: "clientId",
		externalClientId: "externalClientId",
		tenant: "tenant",
		externalId: "externalId",
		userId: "userId",
		candidateId: "candidateId",
		shortId: "shortId",
	},
	pages: ["oauthLogin", "setupUser", "candidateProfile", "chooseFile", "fetchFile", "confirmationPage"],
	props: {
		setupUser: {
			getUserDetails: async (clientId: string, integrationData: IntegrationData) => {
				return await integrationGetUserDetails(integrationData, clientId)
			},
		},
		oauthLogin: {
			newTab: true,
			createStateData: ({ integrationData }) => ({
				shortId: integrationData.shortId,
			}),
			getLoginUrl: (integrationData: IntegrationData, state: string) => {
				// @ts-ignore
				const vincereClientId = integrationData.other.vincereClientId
				return `https://id.vincere.io/oauth2/authorize?response_type=code&client_id=${vincereClientId}&redirect_uri=${callbackUrl}${state != null ? `&state=${encodeURIComponent(state)}` : ""}`
			},
			handleCallback: async (query: URLSearchParams) => {
				query.get("x-code")
			},
		},
		candidateProfile: {},
		chooseFile: {
			listFiles: async (clientId: string, integrationData: IntegrationData) => {
				return await integrationListCVList(integrationData, clientId)
			},
		},
		fetchFile: {
			getFile: async (clientId: string, integrationData: IntegrationData, fileFetchingDetails: FileFetchingDetails) => {
				return await integrationGetCVContent(integrationData, fileFetchingDetails, clientId)
			},
		},
		confirmationPage: {},
	},
	initialData: {},
	useFrontendFileUpload: false,
}
